// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3fFJy","text":"SelectPayment_text__3Y8Qz","title":"SelectPayment_title__2cTx2","btn":"SelectPayment_btn__1vX3q"};